import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import {
    CONTACT_VIEWS,
    ListViewsPage,
    ListViewsPageContext,
} from 'components/tables/list-table/filter-bar/builtInViews';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import ContactsTable from './ContactsTable';

// The new design's views row, which the list draws: the built-in view is named after the list.
const VIEWS_PAGE: ListViewsPage = { listKey: 'contacts', views: CONTACT_VIEWS, activeId: CONTACT_VIEWS[0].id };

const ContactsPage = () => {
    const navigateWithReturn = useNavigateWithReturnState();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId={'contacts.contacts'}
                    showBreadcrumb
                    buttons={
                        <div>
                            <ListCreateButton
                                permissions={[
                                    'CREATE.PARTIES',
                                    'CREATE.PARTIES.CLIENTS',
                                    'CREATE.PARTIES.LEADS_AND_NON_CLIENTS',
                                ]}
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => navigateWithReturn(`/contact/new`)}
                                labelId="contacts.add-new-contact"
                                newLabelId="new-entity.contact"
                            />
                        </div>
                    }
                />
                <ListViewsPageContext.Provider value={VIEWS_PAGE}>
                    <ContactsTable />
                </ListViewsPageContext.Provider>
            </div>
        </PaddedLayout>
    );
};

export default ContactsPage;
